import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AdminGate } from '@/auth/AdminGate';
import { AuthGate } from '@/auth/AuthGate';
import { Layout } from '@/components/Layout';
import EventManagementPage from '@/pages/EventManagementPage';
import NoticeManagementPage from '@/pages/NoticeManagementPage';
import GlobalStatePage from '@/pages/GlobalStatePage';
import GloryShopAnalyticsPage from '@/pages/GloryShopAnalyticsPage';
import DegenPrizeLogPage from '@/pages/DegenPrizeLogPage';
import LoginPage from '@/pages/LoginPage';
import MailSendPage from '@/pages/MailSendPage';
import MaintenancePage from '@/pages/MaintenancePage';
import AssetViewerPage from '@/master-data/assets/AssetViewerPage';
import EnumAdminPage from '@/master-data/enums/EnumAdminPage';
import ManifestPage from '@/master-data/ManifestPage';
import MasterDataPage from '@/master-data/MasterDataPage';
import SqlQueryPage from '@/master-data/sql/SqlQueryPage';
import MigrationPage from '@/pages/MigrationPage';
import NotAdminPage from '@/pages/NotAdminPage';
import SeedingPage from '@/pages/SeedingPage';
import ShopRevenuePage from '@/pages/ShopRevenuePage';
import SeasonRankingsPage from '@/pages/SeasonRankingsPage';
import SeasonValidationPage from '@/pages/SeasonValidationPage';
import DashboardPage from '@/pages/DashboardPage';
import UsersPage from '@/pages/UsersPage';
import FunnelPage from '@/pages/FunnelPage';
import QueryConsolePage from '@/pages/QueryConsolePage';
import { ThemeProvider } from '@/theme/theme-provider';

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/not-admin" element={<NotAdminPage />} />
          <Route
            path="/*"
            element={
              <AuthGate>
                <AdminGate>
                  <Layout />
                </AdminGate>
              </AuthGate>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="funnel" element={<FunnelPage />} />
            <Route path="query-console" element={<QueryConsolePage />} />
            <Route path="migration" element={<MigrationPage />} />
            <Route path="global-state" element={<GlobalStatePage />} />
            <Route path="master-data" element={<MasterDataPage />} />
            <Route path="master-data/manifest" element={<ManifestPage />} />
            <Route path="master-data/sql" element={<SqlQueryPage />} />
            <Route path="master-data/enums" element={<EnumAdminPage />} />
            <Route path="master-data/seeder" element={<SeedingPage />} />
            <Route path="assets" element={<AssetViewerPage />} />
            <Route path="maintenance" element={<MaintenancePage />} />
            <Route path="mail-send" element={<MailSendPage />} />
            <Route path="shop/revenue" element={<ShopRevenuePage />} />
            <Route path="shop/glory" element={<GloryShopAnalyticsPage />} />
            <Route path="degen/prize-log" element={<DegenPrizeLogPage />} />
            <Route path="event-management" element={<EventManagementPage />} />
            <Route path="notice-management" element={<NoticeManagementPage />} />
            <Route path="rankings" element={<SeasonRankingsPage />} />
            <Route path="rankings/validation" element={<SeasonValidationPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
